import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import type { OrderDrawerIdentifier } from "./types";
import {
  OrderCheckoutQuestionsClient,
  OrderCheckoutQuestionDto,
} from "@lib/ShiOneClient";

interface UseOrderCheckoutQuestionsOptions {
  identifier: OrderDrawerIdentifier | null;
  enabled: boolean;
}

export function useOrderCheckoutQuestions({
  identifier,
  enabled,
}: UseOrderCheckoutQuestionsOptions) {
  const api = useApi(OrderCheckoutQuestionsClient);

  const webOrderId = identifier?.webOrderId;
  const biOrderId = identifier?.biOrderId;
  const isWebOrder = (webOrderId ?? 0) > 0 && (biOrderId ?? 0) <= 0;
  const canFetch = enabled && isWebOrder;

  const query = useQuery({
    queryKey: ["order-drawer-checkout-questions", webOrderId ?? null],
    queryFn: async (): Promise<OrderCheckoutQuestionDto[]> => {
      if (!webOrderId || webOrderId <= 0) {
        return [];
      }
      return api.getByWebOrderIdAll(webOrderId);
    },
    enabled: canFetch,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });

  return {
    checkoutQuestions: query.data ?? [],
    isLoading: query.isFetching,
    isError: query.isError,
  };
}
